import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import {
  isUserAuthenticatedSelector,
  sessionIsUserIdentifiedSelector,
} from "@/fe-core/_redux/selectors/sessionSelectors";
import { CookiesStorage } from "@/fe-core/helpers/storage";
import { storageKeys } from "@/config/general";
import { usePathname } from "../navigation";

const withSession = <T extends Record<string, any>>(
  Component: FC<T>,
  redirectPath: string
): FC<T> => {
  const Wrapped: FC<T> = (props) => {
    const pathname = usePathname();
    const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);
    const isUserIdentified = useSelector(sessionIsUserIdentifiedSelector);

    useEffect(() => {
      if (!isUserAuthenticated) {
        CookiesStorage.setItem(storageKeys.RETURN_URL, pathname);
      } else {
        CookiesStorage.removeItem(storageKeys.RETURN_URL);
      }
    }, []);

    useEffect(() => {
      if (isUserIdentified && !isUserAuthenticated) {
        window.location.href = redirectPath;
        // router.push(redirectPath);
        return;
      }
    }, [isUserAuthenticated, redirectPath, isUserIdentified]);

    return !isUserAuthenticated ? null : <Component {...props} />;
  };

  return Wrapped;
};

export default withSession;
